import type {AuditCategoryOfStructure} from './AuditCategoryOfStructure';
import type {AuditRating} from './AuditRating';

export type AuditStructure = {
  id: string;
  validation?: 'validate' | 'nonValidate' | null;
  name: Record<string, string>;
  categories: Array<AuditCategoryOfStructure>;
  ratings: Array<AuditRating>;
  inspectionType?: AuditStructure.inspectionType | null;
};

export namespace AuditStructure {
  export enum validation {
    VALIDATE = 'validate',
    NON_VALIDATE = 'nonValidate',
  }

  export enum inspectionType {
    VALIDATION_INSPECTION = 'validationInspection',
    VEHICLE_CONDITION = 'vehicleCondition',
    NON_VALIDATION_INSPECTION = 'nonValidationInspection',
  }
}
